<template>
    <twilio-conference :username="username" />
</template>

<script>
import TwilioConference from '../components/twilio/TwilioConference.vue'
export default {
	components: { TwilioConference },
    props: {
        username: {type: String, required: true}
    }    
}
</script>